<mat-nav-list class="sidebar-nav">
  <img src="../../../assets/img/wimove_logo.svg" width="150px" height="auto">
  @for (item of menuItems(); track item) {
  <a mat-list-item class="menu-item" [routerLink]="item.route" routerLinkActive="active-menu-item"
    [class.expanded]="isSubmenuOpen(item)" (click)="toggleSubmenu(item, $event)">

    <div class="menu-item-content">
      <span class="menu-label">{{ item.label | translate }}</span>
    </div>
  </a>

  @if (isSubmenuOpen(item) && hasSubmenu(item)) {
  <div class="submenu-level-1">
    @for (subItem of item.submenu; track subItem) {
    <a mat-list-item class="submenu-item" [routerLink]="subItem.route" routerLinkActive="active-menu-item"
      [class.expanded]="isSubmenuOpen(subItem)" (click)="toggleSubmenu(subItem, $event)">

      <div class="submenu-item-content">
        <span class="submenu-label">{{ subItem.label | translate }}</span>
      </div>
    </a>

    @if (isSubmenuOpen(subItem) && hasSubmenu(subItem)) {
    <div class="submenu-level-2">
      @for (subSubItem of subItem.submenu; track subSubItem) {
      <a mat-list-item class="subsubmenu-item" [routerLink]="subSubItem.route" routerLinkActive="active-menu-item">

        <div class="subsubmenu-item-content">
          <span class="subsubmenu-label">{{ subSubItem.label | translate }}</span>
        </div>
      </a>
      }
    </div>
    }
    }
  </div>
  }
  }
</mat-nav-list>